import Blue from "~/core";

new Blue({
  name: "Accordion",
  selector: ".accordion",
  setup(accordion) {
    const accordionItems = [...accordion.querySelectorAll(".accordion__item")];

    accordionItems.forEach((item) => {
      const trigger = item.querySelector(".accordion__trigger");
      const content = item.querySelector(".accordion__content");

      trigger.addEventListener("click", (e) => {
        if (accordion.classList.contains("accordion--dfwjobs")) {
          if (item.classList.contains("accordion__item--expanded")) {
            item.classList.toggle("accordion__item--expanded");

            if (item.classList.contains("accordion__item--expanded")) {
              content.style.maxHeight = content.scrollHeight + "px";
            } else {
              content.style.maxHeight = null;
            }

            return;
          }

          const activeItems = [...accordion.querySelectorAll(".accordion__item--expanded")];

          activeItems.forEach(activeItem => {
            const activeContent = activeItem.querySelector(".accordion__content");
            activeItem.classList.toggle("accordion__item--expanded");
            activeContent.style.maxHeight = null;
          });

          item.classList.toggle("accordion__item--expanded");
          content.style.maxHeight = content.scrollHeight + "px";
        } else if (accordion.classList.contains("accordion--nctcog")) {
          item.classList.toggle("accordion__item--expanded");

          if (item.classList.contains("accordion__item--expanded")) {
            content.style.maxHeight = content.scrollHeight + "px";
          } else {
            content.style.maxHeight = null;
          }
        }
      });
    });
  },
});
